import { render, staticRenderFns } from "./respuestaRecordatorioCorreoPago.vue?vue&type=template&id=77f072ef&scoped=true"
import script from "./respuestaRecordatorioCorreoPago.vue?vue&type=script&lang=js"
export * from "./respuestaRecordatorioCorreoPago.vue?vue&type=script&lang=js"
import style0 from "./respuestaRecordatorioCorreoPago.vue?vue&type=style&index=0&id=77f072ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f072ef",
  null
  
)

export default component.exports